/* eslint-disable no-shadow */
function judgeUserType (userType, self) {
  if (userType === 0 || userType === 1) {
    self.$cubeToast.showToast(self, '请使用法人账号登陆', 'warn', 1500, true)
    return false
  }
  return true
}

// 判断年息范围，决定显示的方式
function judgeAnnualInterestRange (start, end) {
  if (start && end) {
    return `${start}~${end}%`
  } else if (start) {
    return `不低于${start}%`
  } else if (end) {
    return `不高于${end}%`
  }
  return ''
}

// 判断审批时间
function judgeAcceptanceTime (start, end) {
  if (start && end) {
    return `${start}~${end}`
  }
  return ''
}

// 判断期限范围
function judgeTermRange (start, end) {
  if (start && end) {
    return `${start}~${end}月`
  }
  return ''
}

export {
  judgeUserType,
  judgeAnnualInterestRange,
  judgeAcceptanceTime,
  judgeTermRange
}
